import { useEffect, useRef } from 'react'
import { gsap, Power1 } from 'gsap'
import styles from './Whyi3.module.scss'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import TitleFlex from 'components/services/commons/TitleFlex'

gsap.registerPlugin(ScrollTrigger)

const tweenVars: gsap.TweenVars = {
  y: '50',
  duration: 0.5,
  opacity: 0,
  ease: Power1.easeOut,
}

interface Props {
  titleJa?: string
  list: {
    icon: string
    title: string
    text: string | string[]
  }[]
  isGrayBackground?: boolean
}

const Whyi3: React.FC<Props> = ({ list, titleJa, isGrayBackground = false }) => {
  const timeline = gsap.timeline()
  const itemsRef = useRef<HTMLLIElement[]>([])
  const trigger = useRef<HTMLUListElement>()

  useEffect(() => {
    timeline.from('.Whyi3_title', tweenVars, 0.3).from(itemsRef.current, {
      ...tweenVars,
      stagger: 0.3,
    })

    ScrollTrigger.create({
      animation: timeline,
      trigger: trigger.current,
      start: 'top 90%',
      toggleActions: 'play none none reverse',
    })

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
      timeline.kill()
    }
  }, [])

  return (
    <section className={`${styles.wrapper} ${isGrayBackground ? styles.gray_background : ''}`}>
      <div className={styles.inner}>
        <TitleFlex
          sectionTitle={{ title: 'Our features', sub_title: `${titleJa ? titleJa : '選ばれる理由'}` }}
          adjust
        />
        <ul className={`${styles.reason_body} whyi3_container`} ref={trigger}>
          {list.map((item, index) => (
            <li
              key={index}
              ref={(el) => {
                if (el) {
                  itemsRef.current[index] = el
                }
              }}
              className={`${styles.reason_item} Whyi3_item0${index + 1}`}
            >
              <figure className={styles.reason_item_icon}>
                <img src={item.icon} alt={item.title} />
              </figure>
              <div>
                <p className={styles.reason_item_title}>{item.title}</p>
                {/* <p className={styles.reason_item_text}>{item.text}</p> */}
                <p className={styles.reason_item_text}>
                  {Array.isArray(item.text)
                    ? item.text.map((line, idx) => (
                        <span key={idx}>
                          {line}
                          <br />
                        </span>
                      ))
                    : item.text}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default Whyi3
